import axios from "axios";
import { $notify } from "@/toaster/ToasterPlugin";
const endpoint = "owner/coop";
export default {
  async fetchCoops({ commit, state }, isAppend = true) {
    let response;
    try {
      response = await axios.get(state.next_coops_url);
      commit("SET_SUCCESS", true);
      if (isAppend) {
        commit("SET_COOPS", [...state.coops, ...response.data.data]);
      } else {
        commit("SET_COOPS", response.data.data);
      }
      commit("SET_NEXT_COOPS_URL", response.data.links.next);
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors);
      commit("SET_SUCCESS", false);
    }
  },

  async createCoop({ state, commit }, data) {
    let coop;
    try {
      coop = (
        await axios.post(`${endpoint}/store-update`, {
          ...data,
          station_id: data.station?.id,
        })
      ).data;
      commit("SET_SUCCESS", true);
      commit("SET_ERRORS", "");
      if (data.id) {
        commit(
          "SET_COOPS",
          state.coops.map((existedCoop) => {
            return existedCoop.id === coop.id ? coop : existedCoop;
          })
        );
      } else {
        commit("SET_COOPS", [coop, ...state.coops]);
      }
      return coop.id;
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors);
      commit("SET_SUCCESS", false);
      $notify.apiError(e);
    }
  },

  async fetchCoop(context, id) {
    return (await axios.get(`${endpoint}/${id}`)).data.data;
  },

  async destroyCoop({ commit, state }, id) {
    try {
      await axios.post(`${endpoint}/destroy/${id}`);
      commit("SET_SUCCESS", true);
      commit(
        "SET_COOPS",
        state.coops.filter((coop) => {
          return coop.id !== +id;
        })
      );
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors);
      commit("SET_SUCCESS", false);
      $notify.apiError(e);
    }
  },

  searchCoop({ commit }, { keywords, station }) {
    commit(
      "SET_NEXT_COOPS_URL",
      endpoint + "?keywords=" + keywords + "&station_id=" + (station?.id ?? "")
    );
    commit("SET_COOPS", []);
    commit("SET_SEARCH_STATION", station);
    commit("SET_SEARCH_KEYWORD", keywords);
  },
};
